<template>
  <div class="row px-5 getting_started__row">
    <div class="content_row d-flex flex-column">
      <h3 class="getting_started__h3">Create an Ethereum Account</h3>

      <p class="getting_started__p">
        Accounts are generated using a mnemonic seed phrase. (12 random words)
      </p>

      <b-button
        class="mt-2 d-flex justify-content-center"
        align-v="end"
        variant="primary"
        @click="saveWallet"
        :disabled="processing"
      >
        <i class="material-icons mr-2">vertical_align_bottom</i>
        Generate Account</b-button
      >
    </div>

    <div class="content_row d-flex flex-column" v-if="wallet">
      <h3 class="getting_started__h3">Account Details</h3>

      <p class="getting_started__p">
        Accounts are generated using a mnemonic seed phrase. (12 random words)
      </p>

      <form ref="form" class="py-3">
        <b-row class="mb-4">
          <b-col lg="12">
            <b-form-group id="form-group" label="Address" label-for="address">
              <b-form-input
                id="address"
                v-model="wallet.address"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col lg="12">
            <b-form-group id="form-group" label="Mnemonic" label-for="mnemonic">
              <b-form-input
                id="mnemonic"
                v-model="wallet.mnemonic"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col lg="12">
            <b-form-group
              id="form-group"
              label="Raw Private Key"
              label-for="private_key"
            >
              <b-form-input
                id="private_key"
                v-model="wallet.privateKey"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col lg="8">
            <b-form-input
              id="private-key"
              v-model="passphrase"
              placeholder="Passphrase"
              type="password"
              required
            ></b-form-input>
          </b-col>
          <b-col lg="4">
            <b-button type="button" variant="secondary" block @click="saveFile"
              >Generate UTC File</b-button
            >
          </b-col>
        </b-row>
      </form>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import { ethers } from 'ethers'
import Wallet from 'ethereumjs-wallet'
import { toBuffer } from 'ethereumjs-util'
export default {
  data() {
    return {
      wallet: null,
      processing: false,
      show: true,
      passphrase: ''
    }
  },
  methods: {
    saveFile: function() {
      // saveAs

      const { wallet, passphrase } = this

      if (!passphrase) return

      if (!wallet) return

      const key = toBuffer(wallet.privateKey)

      const wallet_instance = Wallet.fromPrivateKey(key)

      const data = wallet_instance.toV3String(this.passphrase)

      var blob = new Blob([data], {
        type: 'application/file'
      })

      saveAs(blob, 'utc-file')
    },
    saveWallet: async function() {
      // saveAs

      this.processing = !this.processing

      let randomWallet = await ethers.Wallet.createRandom()

      this.wallet = randomWallet

      console.log(this.wallet)

      this.processing = !this.processing
    }
  }
}
</script>

<style scoped>
* {
}

.getting_started__row {
  max-width: 800px;
}

.content_row {
  margin-bottom: 32px;
}

.getting_started__h1,
.getting_started__h2,
.getting_started__h3,
.getting_started__h4,
.getting_started__h5,
.getting_started__h6 {
  padding-bottom: 0.7em;
  border-bottom: 1px solid #ddd;
  width: 100%;
}

.getting_started__p {
  margin: 0.6rem 0;
  word-spacing: 0.05em;
  line-height: 1.6em;
}
</style>
